import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import ABOUTUS from "./pages/AboutUs";
import ENGINEERINGSAFTEY from "./pages/EngineeringSafety";
import XCUBE from "./pages/XCube";
import PARTSSERVICES from "./pages/PartsServices";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AboutUs" element={<ABOUTUS />} />
        <Route path="/Engineering&Safety" element={<ENGINEERINGSAFTEY />} />
        <Route path="/XCube" element={<XCUBE />} />
        <Route path="/Parts&Services" element={<PARTSSERVICES />} />
      </Routes>
    </Router>
  );
}

export default App;
